<template>
  <div class="zs-comment-dept-container">
    <InfoContainer
      :infoTitle="InfoContainerConfig['infoTitle']"
      :contentConfig="InfoContainerConfig['infoContent']"
    >
      <template #basicInfo>
        <div class="comment-container">
          <div v-for="(item, index) in showCommentsData" :class="['comment-one', index == showCommentsData.length - 1 ? 'comment-one-last' : '']" :key="index">
            <div class="comment-item"><span class="item-title">分发时间：</span> {{ item.claimTime }}</div>
            <div class="comment-item"><span class="item-title">分发部门：</span>{{ item.variables.zs_accept_dept_name }}</div>
            <div class="comment-item"><span class="item-title">分发人：</span>{{ item.assigneeName }}</div>
          </div>
        </div>
      </template>
    </InfoContainer>
  </div>
</template>
<script>
import InfoContainer from "@/components/infoContainer/infoContainer";
export default {
  name: 'zsCommentDept',
  data() {
    return {
      showCommentsData: [],
      InfoContainerConfig: {
        infoTitle: '分发记录',
        infoContent: [{
          title: '',
          prop: 'basicInfo'
        }]
      }
    }
  },
  components: {
    InfoContainer,
  },  
  props: {
    commentList: {
      type: Array,
      default: ()=> {
        return []
      }
    },
  },
  watch: {
    commentList: {
      handler(val) {
        this.filterDeptList(val)
      },
      immediate: true
    }
  },
  methods: {
    filterDeptList(val) {
      val.map(item => {
        if(item.historyActivityId == "Activity_ct_distribute") {
          this.showCommentsData.push(item)
        }
      })
      console.info(this.showCommentsData, 'filterDeptList')

    }
  }
}
</script>
<style lang="scss" scoped>
.zs-comment-dept-container{
  /deep/.detail-one{
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .comment-one{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #eee;
    .item-title{
      color: #999;
      margin-right: 10px;
    }
  }
  .comment-one-last{
    border-bottom: none !important;
  }
}
</style>